<p class="measurements">
  #{{ 'dashboard.measurements' | translate }}: {{ measurementCount }}
</p>
